import { render } from "./AmendedItem.vue?vue&type=template&id=44e3614d&scoped=true"
import script from "./AmendedItem.vue?vue&type=script&lang=js"
export * from "./AmendedItem.vue?vue&type=script&lang=js"

import "./AmendedItem.vue?vue&type=style&index=0&id=44e3614d&lang=scss&scoped=true"
import "../style.scss?vue&type=style&index=1&id=44e3614d&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e3614d"]])

export default __exports__